/**
 * A long press belongs to the game (a pawn's Epitaph, MatchScreen.tsx): it brings up no menu on
 * phones. The stylesheet keeps text from being selected and iOS from showing its callout
 * (styles.css); this keeps Android's context menu away, for touches only: a mouse's right click
 * keeps its menu, and text fields keep theirs.
 */
export function noTouchMenus(target: Window = window): void {
  let touch = false;
  target.addEventListener(
    'pointerdown',
    (e) => {
      touch = e.pointerType !== 'mouse';
    },
    { capture: true, passive: true },
  );
  target.addEventListener('contextmenu', (e) => {
    const field = e.target instanceof Element && e.target.closest('input, textarea');
    if (touch && !field) e.preventDefault();
  });
}
